import {
  UserPreferencesKeys,
  UserPreferencesResponse,
} from './useUserPreferences.types';

const DEFAULT_USER_PREFERENCES: UserPreferencesResponse = [
  {
    key: UserPreferencesKeys.TUTORIAL_ADD_WALLET,
    value: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    key: UserPreferencesKeys.TUTORIAL_PAYMENT_LINK,
    value: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    key: UserPreferencesKeys.TUTORIAL_COMPLETED,
    value: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
];

export default { DEFAULT_USER_PREFERENCES };
